import { useCallback, useEffect, useState } from 'react';

import { getAdminOverview, type AdminOverview } from '../api/admin';

export function useAdminOverview() {
  const [overview, setOverview] = useState<AdminOverview | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const overviewResponse = await getAdminOverview();
      setOverview(overviewResponse.data.data);
      return overviewResponse.data.data;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh().catch(() => {
      setOverview(null);
    });
  }, [refresh]);

  return { overview, loading, refresh };
}
